/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Annexe_NameInputs */

const en_resources_annexe_name = /** @type {(inputs: Resources_Annexe_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annexe integration`)
};

const fr_resources_annexe_name = /** @type {(inputs: Resources_Annexe_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration des annexes`)
};

const es_resources_annexe_name = /** @type {(inputs: Resources_Annexe_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de anexos`)
};

const de_resources_annexe_name = /** @type {(inputs: Resources_Annexe_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anhang-Integration`)
};

const nl_resources_annexe_name = /** @type {(inputs: Resources_Annexe_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijlage-integratie`)
};

/**
* | output |
* | --- |
* | "Annexe integration" |
*
* @param {Resources_Annexe_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_annexe_name = /** @type {((inputs?: Resources_Annexe_NameInputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Annexe_NameInputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_annexe_name(inputs)
	if (locale === "fr") return fr_resources_annexe_name(inputs)
	if (locale === "es") return es_resources_annexe_name(inputs)
	if (locale === "de") return de_resources_annexe_name(inputs)
	return nl_resources_annexe_name(inputs)
});
export { resources_annexe_name as "resources.annexe.name" }